import React, { memo } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import styles from '../styles/MenuTooltip';
const useStyles = createUseStyles(styles, 'MenuTooltip');

const MenuTooltip = memo(({ className: classNameProp, name = '', top = 0, toolTipOffset = 0 }) => {
    const classes = useStyles();

    const rootClassName = classnames(classes.root, classNameProp);

    return (
        <span
            className={rootClassName}
            id="fmMenuTooltip"
            style={{
                transform: `translate3d(0, ${top - toolTipOffset}px, 0)`,
            }}
        >
            {name}
        </span>
    );
});

MenuTooltip.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    top: PropTypes.number,
};

export default MenuTooltip;
